module.exports = __webpack_public_path__ + "static/LEPA-Corona-Virus-64c444e76fada3ddbad6a20eca3e3d05.pdf";